var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-not-found"},[_c('button',{attrs:{"disabled":_vm.disabled},on:{"click":_vm.handleSubmit}},[_vm._v("未找到相应技巧")])])}
var staticRenderFns = []

export { render, staticRenderFns }